import './style.less';

export const InputRows = ({ children }) => {
  return (
    <>
      <div className="input-row">{children}</div>
    </>
  );
};
